import { updatePositions, setUpCollapsibleForm } from "../../../util/methods"
import { initSortable } from "../../../util/sortable"

$(document).on("turbolinks:load", function () {
  var $bundleFaqsContainer = $("#js-productBundle-faqs")

  if ($bundleFaqsContainer.length) {
    initSortable(
      $bundleFaqsContainer[0],
      ".js-productBundle-faq",
      ".draggable-handle",
      function () {
        updatePositions($(".js-productBundle-faq:visible"))
      }
    )

    $bundleFaqsContainer
      .on("cocoon:after-insert", function (e, $insertedItem) {
        if ($insertedItem.hasClass("js-productBundle-faq")) {
          updatePositions($(".js-productBundle-faq:visible"))
          setUpCollapsibleForm($insertedItem)
        }
      })
      .on("cocoon:after-remove", function (e, $removedItem) {
        if ($removedItem.hasClass("js-productBundle-faq")) {
          updatePositions($(".js-productBundle-faq:visible"))
        }
      })
  }
})
